import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "search-equals",
  style: {"display":"flex","align-items":"center","margin-top":"8px"}
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 3,
  style: {"color":"gray","cursor":"not-allowed"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_lable = _resolveComponent("lable")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, { spinning: _ctx.loadingType }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("label", { style: {"vertical-align":"middle"} }, "MBOL:", -1)),
        _createVNode(_component_a_input_search, {
          value: _ctx.bill_search,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bill_search) = $event)),
          placeholder: "Search",
          onSearch: _ctx.searchMbolHanlde,
          style: {"vertical-align":"middle","margin-left":"20px","width":"240px"},
          allowClear: ""
        }, null, 8, ["value", "onSearch"])
      ]),
      _createVNode(_component_a_table, {
        dataSource: _ctx.dataSource,
        columns: _ctx.columns_info,
        style: {"margin-top":"8px"},
        pagination: _ctx.pageData,
        onChange: _ctx.tableChangeHandle
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.key === 'actions')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (record.status !== 'Draft')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (record.aiScanStatus === 'Scanned' && record.status === 'Approved')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.checkHtsHandle(record))
                          }, "Check", 8, _hoisted_2))
                        : (_openBlock(), _createBlock(_component_lable, {
                            key: 1,
                            style: {"color":"gray","cursor":"not-allowed"}
                          }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createTextVNode("Check")
                            ])),
                            _: 1
                          })),
                      _createVNode(_component_a_divider, { type: "vertical" }),
                      (record.status === 'Approved' )
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.sendToCC(record))
                          }, "Send", 8, _hoisted_3))
                        : (_openBlock(), _createElementBlock("label", _hoisted_4, "Send")),
                      _createVNode(_component_a_divider, { type: "vertical" }),
                      _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
                        overlay: _withCtx(() => [
                          _createVNode(_component_a_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_menu_item, { key: "1" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.downloadFileHandle('T86', record))
                                  }, "T86", 8, _hoisted_5)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_menu_item, { key: "2" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.downloadFileHandle('ISF', record))
                                  }, "ISF", 8, _hoisted_6)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_menu_item, { key: "3" }, {
                                default: _withCtx(() => [
                                  (record.transportMode==='OCEAN')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.downloadFileHandle('AMS', record))
                                      }, "AMS", 8, _hoisted_7))
                                    : (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.downloadFileHandle('ACAS', record))
                                      }, "ACAS", 8, _hoisted_8))
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_menu_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.downloadFileHandle('T86V2', record))
                                  }, "Ocean T86 V2", 8, _hoisted_9)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            class: "ant-dropdown-link",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                          }, " Download ")
                        ]),
                        _: 2
                      }, 1024)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : (column.key === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.status === 'Draft')
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "red"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(record.status), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (record.status === 'Approved')
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 1,
                          color: "green"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.status), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (record.status === 'Uploading')
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 2,
                            color: "processing"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(record.status), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_a_tag, {
                            key: 3,
                            color: "green"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(record.status), 1)
                            ]),
                            _: 2
                          }, 1024))
                ], 64))
              : (column.key === 'masterBillNumber' )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(record.masterBillNumber), 1),
                    _createVNode(_component_CopyOutlined, {
                      onClick: ($event: any) => (_ctx.copyMbolHandle(record.masterBillNumber)),
                      style: {"margin-left":"8px","color":"#1677ff"}
                    }, null, 8, ["onClick"])
                  ], 64))
                : (column.key === 'firstLogisticsProviderName')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_10, _toDisplayString(record.firstLogisticsProviderName), 1))
                  : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "pagination", "onChange"])
    ]),
    _: 1
  }, 8, ["spinning"]))
}